import { render, staticRenderFns } from "./HsabExpenseCardRowPaymentDetail.vue?vue&type=template&id=2d3cbbf2&scoped=true"
import script from "./HsabExpenseCardRowPaymentDetail.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardRowPaymentDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d3cbbf2",
  null
  
)

export default component.exports